module.exports = __webpack_public_path__ + "img/case22-jpg.395e4342.jpg";